
import { defineComponent } from 'vue';
import { useDeviceSize } from 'SharedDir/common/composables/useDeviceSize';
import { random } from 'SharedDir/utils/helpers';

export default defineComponent({
  name: 'ServiceSkeletonItem',
  methods: { random },
  setup(props) {
    const { isMobile } = useDeviceSize();

    return { props, isMobile };
  },
});
